// `buildRankDictionary` takes in an ordered array of strings and returns an
// object that maps each string into its index in the array.
export function buildRankDictionary(arr) {
    const dict = {};
    for (let i = 0; i < arr.length; i++) {
        dict[arr[i]] = i;
    }
    return dict;
}
